import { IGetAllTreinamentoFuncionarioDataUseCase } from "../../../presentation/useCases/read/get_all_treinamento_funcionario_data_use_case";
import { TreinamentoFuncionarioData } from "../../models/treinamento_funcionario_data";
import { IRhRepository } from "../../repositories/rh_repository";

/**
 * GetAllTreinamentoFuncionarioDataUseCase
 */

export class GetAllTreinamentoFuncionarioDataUseCase implements IGetAllTreinamentoFuncionarioDataUseCase {
  constructor(private readonly repository: IRhRepository) { }

  async getAllTreinamentoFuncionarioData(): Promise<TreinamentoFuncionarioData[]> {
    return await this.repository.getAllTreinamentoFuncionarioData();
  }
}
